import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";

function FilesDirectoryBreadcrumbs({
  currentDirectory,
  handleSelectDirectory,
}) {
  const { current_path, name } = currentDirectory;

  // Split the path into segments and filter out empty strings
  const pathSegments = current_path
    ? current_path.split("/").filter(Boolean)
    : [];

  return (
    <Breadcrumbs sx={{ mb: 2.5 }} aria-label="breadcrumb">
      <Link
        key="root"
        underline="hover"
        color="inherit"
        component="button"
        onClick={() => handleSelectDirectory()}
        sx={{ cursor: "pointer" }}>
        Files
      </Link>
      {pathSegments.map((segment, index) => {
        const isLast = index === pathSegments.length - 1;
        const currentPath = pathSegments.slice(0, index + 1).join("/");

        if (isLast) {
          return (
            <Typography key={segment} color="text.primary">
              {segment}
            </Typography>
          );
        } else {
          return (
            <Link
              key={segment}
              underline="hover"
              color="inherit"
              component="button"
              onClick={() => handleSelectDirectory(currentPath)}
              sx={{ cursor: "pointer" }}>
              {segment}
            </Link>
          );
        }
      })}
    </Breadcrumbs>
  );
}

export default FilesDirectoryBreadcrumbs;
